import { render, staticRenderFns } from "./PersonalAbilityScale.vue?vue&type=template&id=3bbbc3bd&scoped=true"
import script from "./PersonalAbilityScale.vue?vue&type=script&lang=js"
export * from "./PersonalAbilityScale.vue?vue&type=script&lang=js"
import style0 from "./PersonalAbilityScale.vue?vue&type=style&index=0&id=3bbbc3bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbbc3bd",
  null
  
)

export default component.exports